export interface IDateRange {
  start: Date;
  end: Date;
}
